// Auth
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

// Products
export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_PRODUCT = 'GET_PRODUCT';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const PRODUCT_ERROR = 'PRODUCT_ERROR';
export const CLEAR_PRODUCT = 'CLEAR_PRODUCT';

// Orders
export const GET_ORDERS = 'GET_ORDERS';
export const GET_ORDER = 'GET_ORDER';
export const CREATE_ORDER = 'CREATE_ORDER';
export const UPDATE_ORDER = 'UPDATE_ORDER';
export const CANCEL_ORDER = 'CANCEL_ORDER';
export const ORDER_ERROR = 'ORDER_ERROR';
export const CLEAR_ORDER = 'CLEAR_ORDER';

// Admin
export const GET_USERS = 'GET_USERS';
export const GET_STATS = 'GET_STATS';
export const ADMIN_ERROR = 'ADMIN_ERROR';
// Add this line to your types.js file
export const DELETE_USER = 'DELETE_USER';


// UI
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const SET_LOADING = 'SET_LOADING';
